import { render, staticRenderFns } from "./dealProcess.vue?vue&type=template&id=339e1b12&scoped=true&"
import script from "./dealProcess.vue?vue&type=script&lang=js&"
export * from "./dealProcess.vue?vue&type=script&lang=js&"
import style0 from "./dealProcess.vue?vue&type=style&index=0&id=339e1b12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339e1b12",
  null
  
)

export default component.exports